import React  from 'react'
import { View, StyleSheet } from 'react-native'
import { Icon, Text, Button, useTheme } from '@ui-kitten/components'
import { FontAwesome5 } from '@expo/vector-icons'
import { useTranslation } from 'react-i18next'
import { currencyFormatterAtom, storesDictAtom, userRoleAtom, usersDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import OperationsList from '../../components/OperationsList'


export default function RevisionsScreen({ navigation }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const usersDict = useAtomValue(usersDictAtom)
  const currencyFormatter = useAtomValue(currencyFormatterAtom)
  const storesDict = useAtomValue(storesDictAtom)
  const userRole = useAtomValue(userRoleAtom)
  
  const renderItemFieldsToShow = (item, date) => {
    return (
      <>
        <View style={styles.dateTimeView}>
          <Icon name='file-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {item.productCategory?.text || item.productCategory?.name || '—'}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='credit-card-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {currencyFormatter.format(item.amount)}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='edit-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {currencyFormatter.format(item.correctedAmount)}
          </Text>
        </View>
        
        <View style={styles.dateTimeView}>
          <Icon name='clock-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {date}
          </Text>
        </View>

        <View style={styles.dateTimeView}>
          <Icon name='person-outline' width={16} height={16} fill={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {usersDict[item.cashierUID]?.name}
          </Text>
        </View>
        
        <View style={styles.dateTimeView}>
          <FontAwesome5 name="building" size={16} color={theme['text-basic-color']} style={styles.icon} />
          <Text
            style={styles.itemTitle}
            category='s2'>
            {storesDict?.[item.store]?.name}
          </Text>
        </View>
      </>
    )
  }

  const topView = () => {
    if (userRole?.permissions?.['Stats'] || userRole?.id === 'admin') {
      return (
        <Button style={{alignSelf: 'flex-end'}} appearance='ghost' size='small' onPress={() => {
          navigation.navigate('RevisionStats')}}
          accessoryLeft={(props) => (<Icon name='bar-chart-outline' {...props} style={{...props.style, marginRight: 0}} />)}
        >
          {t('revisions.revisionStats')}
        </Button>
      )
    } else {
      return null
    }
  }

  return (
    <View style={styles.container}>      
      <OperationsList collectionName='revisions' dateField={'date'} additionalFilters={null} 
        detailScreenName={'RevisionDetail'} topView={topView} initialRange={null}
        showTotalSum={false} totalSumFormatter={currencyFormatter} totalSumField={'correctedAmount'}
        showAddButton={true} additionalDataValidation={() => {}} detailScreenParams={{}}
        renderItemFieldsToShow={renderItemFieldsToShow} navigation={navigation} showStoreFilter={true}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  icon: {
    marginRight: 4,
  },
  itemTitle: {
    marginRight: 25,
  },
  dateTimeView: {
    flexDirection: 'row',
    alignItems: 'center'
  },
});
